/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface APIApiClientTokenCreateModel {
  /** A user-friendly name for the API client token, used for identification purposes. */
  name?: string;
  /**
   * The ID of the organization that the API client token belongs to.
   * @format uuid
   */
  organizationId?: string;
  /**
   * The expiration date of the API client token. If null, the token does not expire.
   * @format date
   */
  expiresAt?: null | string;
}

export interface APIApiClientTokenInfo {
  /** @format uuid */
  id?: string;
  name?: string;
}

export interface APIApiClientTokenModel {
  /** A user-friendly name for the API client token, used for identification purposes. */
  name?: string;
  /** The actual token string that will be used for authentication when making API requests. */
  token?: string;
  /**
   * The ID of the organization that the API client token belongs to.
   * @format uuid
   */
  organizationId?: string;
  /**
   * The ID of the user who created the API client token.
   * @format uuid
   */
  createdById?: string;
  /**
   * The expiration date of the API client token. If null, the token does not expire.
   * @format date
   */
  expiresAt?: null | string;
  /** Indicates whether the API client token is currently enabled and can be used for authentication. */
  isEnabled?: boolean;
  /**
   * The date and time when the API client token was last used for authentication.
   * @format date-time
   */
  lastUsedAt?: null | string;
  /**
   * The date and time when the API client token was created.
   * @format date-time
   */
  createdOn?: string;
  /** @format uuid */
  id: string;
}

export interface APIApiClientTokenSearchFilter {
  /** Filter by token name, supports partial match. Case insensitive. */
  name?: APIStringSearchFilter;
  /** Filter by token value, supports partial match. Case insensitive. */
  token?: APIStringSearchFilter;
  /** Filter by enabled/disabled status. If null, will return both enabled and disabled tokens. */
  isEnabled?: null | boolean;
  /** Filter by token creation date (date part only). */
  createdOn?: APIDateOnlySearchFilter;
  /** Filter by token expiration date (date part only). */
  expiresAt?: APIDateOnlySearchFilter;
  /** The search parameter that will be used to search contains criteria the organization ids */
  organizationIds?: string[];
  /** a collection of sort fields */
  searchSortOrders?: APISearchSortOrder[];
  /**
   * The search page number, will be used for offset
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 0
   */
  pageNumber?: number | string;
  /**
   * The count of entities on the page
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 20
   */
  pageSize?: number | string;
}

export interface APIAuditModel {
  eventType: APIEventType;
  entityType: APIEntityType;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  entityId: string;
  /** Represents a user in the EasyECheck system with their personal information and organizational relationships */
  createdBy?: APIUserModel;
  createdByToken?: APIApiClientTokenInfo;
  data?: string[];
  /** @format uuid */
  organizationId: string;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  id: number | string;
}

/** Filter for audit search with advanced filtering options */
export interface APIAuditSearchFilter {
  /** The search parameter that will be used to search contains criteria the event type */
  eventType?: null | APIEventType;
  /** The search parameter that will be used to search contains criteria the entity type */
  entityType?: null | APIEntityType;
  /** Filter for entity id with condition operators */
  entityId?: APIStringSearchFilter;
  /** Filter for created by user with condition operators */
  createdBy?: APIStringSearchFilter;
  /** Filter for created at timestamp with condition operators */
  createdAt?: APIDateOnlySearchFilter;
  /** Filter for searching within audit data entries with condition operators */
  data?: APIStringSearchFilter;
  /** The search parameter that will be used to search contains criteria the organization ids */
  organizationIds?: string[];
  /** a collection of sort fields */
  searchSortOrders?: APISearchSortOrder[];
  /**
   * The search page number, will be used for offset
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 0
   */
  pageNumber?: number | string;
  /**
   * The count of entities on the page
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 20
   */
  pageSize?: number | string;
}

/** Represents banking information for payment processing */
export interface APIBankModel {
  /**
   * The bank routing number used for payment transactions
   * @maxLength 22
   * @example "021000021"
   */
  routing: string;
  /**
   * The bank account number
   * @maxLength 22
   * @example 123456789
   */
  account: string;
  /**
   * The name associated with the bank account
   * @maxLength 100
   * @example "Checking Account"
   */
  accountName: string;
  /**
   * The name of the financial institution
   * @maxLength 100
   * @example "First National Bank"
   */
  bankName: string;
  /**
   * The name of the company that owns the bank account
   * @maxLength 100
   * @example "Acme Corporation"
   */
  companyName: string;
  /**
   * The street address associated with the bank account
   * @maxLength 255
   * @example "123 Main Street"
   */
  address: string;
  /**
   * The city associated with the bank account address
   * @maxLength 100
   * @example "Boston"
   */
  city: string;
  /**
   * The state or province associated with the bank account address
   * @maxLength 2
   * @example "MA"
   */
  state?: string;
  /**
   * The postal code associated with the bank account address
   * @maxLength 20
   * @example "02101"
   */
  zip: string;
  /** The organization this payee belongs to */
  organization?: APIOrganizationModel;
  /**
   * The date and time when this bank record was created
   * @format date-time
   * @example "2023-01-15T14:30:00Z"
   */
  createdOn?: string;
  /**
   * The date and time when this bank record was last updated
   * @format date-time
   * @example "2023-01-16T09:45:00Z"
   */
  updatedOn?: null | string;
  /** @format uuid */
  id: string;
}

export interface APIBankRequestModel {
  /**
   * The bank routing number used for payment transactions
   * @maxLength 22
   * @example "021000021"
   */
  routing: string;
  /**
   * The bank account number associated with the payment
   * @maxLength 22
   * @example 12345678901234
   */
  account: string;
  /**
   * The name of the account holder as it appears on the bank account
   * @maxLength 100
   * @example "John Doe"
   */
  accountName: string;
  /**
   * The name of the financial institution where the account is held
   * @maxLength 100
   * @example "Chase Bank"
   */
  bankName: string;
  /**
   * The name of the company associated with the bank account
   * @maxLength 100
   * @example "Acme Corporation"
   */
  companyName: string;
  /**
   * The street address associated with the bank account or company
   * @maxLength 255
   * @example "123 Main Street"
   */
  address: string;
  /**
   * The city of the address associated with the bank account or company
   * @maxLength 100
   * @example "New York"
   */
  city: string;
  /**
   * The state of the address associated with the bank account or company
   * @maxLength 2
   * @example "NY"
   */
  state: string;
  /**
   * The ZIP code of the address associated with the bank account or company
   * @maxLength 20
   * @example 10001
   */
  zip: string;
}

/** Filter for bank search */
export interface APIBankSearchFilter {
  /** The search parameter that will be used to search contains criteria the id */
  id?: string;
  /** Filter for routing number with condition operators (contains, equals, startsWith, etc.) */
  routing?: APIStringSearchFilter;
  /** Filter for account number with condition operators */
  account?: APIStringSearchFilter;
  /** Filter for account name with condition operators */
  accountName?: APIStringSearchFilter;
  /** Filter for bank name with condition operators */
  bankName?: APIStringSearchFilter;
  /** Filter for company name with condition operators */
  companyName?: APIStringSearchFilter;
  /** Filter for address with condition operators */
  address?: APIStringSearchFilter;
  /** Filter for city with condition operators */
  city?: APIStringSearchFilter;
  /** Filter for state with condition operators */
  state?: APIStringSearchFilter;
  /** Filter for zip with condition operators */
  zip?: APIStringSearchFilter;
  /** Filter for created date with condition operators */
  createdOn?: APIDateOnlySearchFilter;
  /** a collection of sort fields */
  searchSortOrders?: APISearchSortOrder[];
  /**
   * The search page number, will be used for offset
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 0
   */
  pageNumber?: number | string;
  /**
   * The count of entities on the page
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 20
   */
  pageSize?: number | string;
}

/**
 * A subscription charge, read live from Stripe rather than stored. Stripe is the record of what was
 * actually billed, so copying invoices into our own tables could only ever drift from it.
 */
export interface APIBillingInvoiceModel {
  /**
   * The Stripe invoice identifier.
   * @example "in_1Ab2Cd3Ef4Gh5Ij"
   */
  id?: string;
  /**
   * Human-readable invoice number.
   * @example "ABCD1234-0001"
   */
  number?: string;
  /**
   * What the invoice covers, taken from the invoice description or the period it bills.
   * @example "Starter — 13 Aug 2026 to 13 Sep 2026"
   */
  description?: string;
  /**
   * Amount actually paid in USD.
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   * @example 19
   */
  amountPaid?: number | string;
  /**
   * Stripe's invoice status.
   * @example "paid"
   */
  status?: string;
  /** Whether the invoice has been settled. */
  isPaid?: boolean;
  /**
   * When the invoice was issued.
   * @format date-time
   */
  createdOn?: string;
  /** Stripe-hosted page for viewing and paying the invoice. */
  hostedInvoiceUrl?: string;
  /** Direct link to the invoice PDF. */
  invoicePdfUrl?: string;
}

/**
 * Everything the organization's billing page needs in one call: what it has used, what it is
 * paying for, and what it can buy.
 */
export interface APIBillingOverviewModel {
  /** Current usage and remaining allowance. */
  usage?: APIOrganizationUsageModel;
  /**
   * The organization's subscription, or null when it has never subscribed and so is on the free
   * plan.
   */
  subscription?: APIOrganizationSubscriptionModel;
  /** The plan the allowance is being drawn from, whether subscribed to or defaulted into. */
  currentPlan?: APIBillingPlanModel;
  /** The plans on offer, cheapest first. */
  plans?: APIBillingPlanModel[];
  /** The pack pricing table, smallest quantity first. */
  packTiers?: APICheckPackTierModel[];
  /**
   * Purchased checks still available.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 180
   */
  packChecks?: number | string;
  /**
   * Purchased checks spent to date.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 70
   */
  packChecksUsed?: number | string;
  /**
   * Bank accounts the organization has, so the page can show it against the plan's limit.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 2
   */
  bankAccountCount?: number | string;
  /**
   * Whether Stripe is configured in this environment. False hides every checkout button, since
   * nothing can be charged.
   */
  isStripeConfigured?: boolean;
}

/**
 * A subscription plan on offer, as shown in the pricing table. Defined in
 * BillingCatalogue rather than stored, so string BillingPlanModel.Code is its identity.
 */
export interface APIBillingPlanModel {
  /**
   * Stable identifier used in code and Stripe metadata.
   * @maxLength 40
   * @example "Pro"
   */
  code: string;
  /**
   * Plan name shown to customers.
   * @maxLength 80
   * @example "Pro"
   */
  name: string;
  /**
   * One-line summary of the plan's features.
   * @maxLength 400
   * @example "5 bank accounts, custom check designer, custom email templates, and API access"
   */
  description?: string;
  /**
   * Recurring price per month in USD.
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   * @example 49
   */
  monthlyPrice?: number | string;
  /**
   * Checks included, per month or per bank account depending on
   * bool BillingPlanModel.IncludedChecksPerBank.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 130
   */
  includedChecks?: number | string;
  /** Whether int BillingPlanModel.IncludedChecks is granted per bank account rather than per month. */
  includedChecksPerBank?: boolean;
  /**
   * Price per check beyond the allowance. Null means pack pricing applies.
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   * @example 0.55
   */
  extraCheckPrice?: null | number | string;
  /**
   * Bank accounts allowed; -1 is unlimited.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 5
   */
  maxBankAccounts?: number | string;
  /** Whether checks carry the EasyECheck badge. */
  showBadge?: boolean;
  /** Whether the custom check designer is unlocked. */
  hasCheckDesigner?: boolean;
  /** Whether custom email templates are unlocked. */
  hasCustomEmailTemplates?: boolean;
  /** Whether API access is unlocked. */
  hasApiAccess?: boolean;
  /** Whether priority support is included. */
  hasPrioritySupport?: boolean;
  /** Whether the plan is sold on a contract and has to go through Sales. */
  isCustom?: boolean;
  /**
   * The Stripe price the subscription checkout charges. Filled from configuration when the plan
   * is served, because it differs per Stripe account and so cannot live in code.
   * @maxLength 120
   * @example "price_1Ab2Cd3Ef4Gh5Ij6Kl7Mn8Op"
   */
  stripePriceId?: string;
  /** Whether the plan is offered. */
  isActive?: boolean;
  /**
   * Position in the pricing table, ascending.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  sortOrder?: number | string;
  /**
   * Whether a customer can subscribe to this plan without help. A paid plan needs a Stripe price
   * configured; a custom plan never qualifies.
   */
  isSelfServable?: boolean;
}

export interface APIBodyRange {
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
   */
  start?: number | string;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
   */
  end?: null | number | string;
}

/** Request model for bulk resending payments */
export interface APIBulkResendRequestModel {
  /**
   * The list of payment IDs to resend
   * @minItems 1
   */
  paymentIds: string[];
}

/** A Stripe-hosted page for the customer to be sent to. */
export interface APICheckoutSessionModel {
  /**
   * The URL to redirect the browser to. Empty when nothing had to be charged, so the change is
   * already in force.
   * @example "https://checkout.stripe.com/c/pay/cs_test_a1b2c3"
   */
  url?: string;
  /**
   * The pending purchase the checkout was opened for. Null on a subscription checkout, which buys
   * no pack.
   */
  purchase?: APICheckPurchaseModel;
}

/**
 * What a given number of checks costs. Returned before checkout so the customer sees the tier
 * price the server will actually charge, rather than one the browser worked out.
 */
export interface APICheckPackQuoteModel {
  /**
   * Checks quoted for.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 250
   */
  quantity?: number | string;
  /**
   * Price per check from the matching tier. Zero when no tier matches.
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   * @example 0.76
   */
  pricePerCheck?: number | string;
  /**
   * Total for the pack in USD.
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   * @example 190
   */
  totalAmount?: number | string;
  /**
   * Smallest quantity that can be bought self-serve.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 10
   */
  minQuantity?: number | string;
  /**
   * Largest quantity that can be bought self-serve; above this Sales handles the order.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 10000
   */
  maxQuantity?: number | string;
  /** Whether the quantity exceeds what self-serve covers and has to go through Sales. */
  requiresSales?: boolean;
  /**
   * Why the quantity cannot be checked out, or null when it can.
   * @example "Purchases above 10,000 checks are handled by Sales."
   */
  unavailableReason?: string;
  /** Whether checkout can proceed for this quantity. */
  isPurchasable?: boolean;
}

/** One quantity band of the check pack pricing table, defined in BillingCatalogue. */
export interface APICheckPackTierModel {
  /**
   * Smallest quantity the band covers, inclusive.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 100
   */
  minQuantity?: number | string;
  /**
   * Largest quantity the band covers, inclusive. Null is open-ended.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 249
   */
  maxQuantity?: null | number | string;
  /**
   * Price per check in USD inside the band.
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   * @example 0.82
   */
  pricePerCheck?: number | string;
}

/** One check pack purchase, as listed in the organization's billing history. */
export interface APICheckPurchaseModel {
  /**
   * Checks bought.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 250
   */
  quantity?: number | string;
  /**
   * Price per check charged at the time of purchase.
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   * @example 0.76
   */
  pricePerCheck?: number | string;
  /**
   * Total charged in USD.
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   * @example 190
   */
  totalAmount?: number | string;
  /** Settlement state. */
  status?: APICheckPurchaseStatus;
  /**
   * When the payment cleared and the balance was credited.
   * @format date-time
   */
  paidOn?: null | string;
  /**
   * When the checkout was started.
   * @format date-time
   */
  createdOn?: string;
  /** @format uuid */
  id: string;
}

/** Settlement state of a check pack purchase. */
export enum APICheckPurchaseStatus {
  Pending = 'Pending',
  Paid = 'Paid',
  Failed = 'Failed',
}

export interface APICheckTemplateModel {
  basePdf?: string;
  schemas?: APISchema[][];
  pdfmeVersion?: string;
}

/**
 * The kind of allowance a super admin has granted an organization, overriding whatever plan it is
 * on. One value rather than a set of flags, because the modes are mutually exclusive and every
 * combination of booleans but one was meaningless.
 */
export enum APICreditGrantType {
  None = 'None',
  Monthly = 'Monthly',
  Lifetime = 'Lifetime',
  Unlimited = 'Unlimited',
}

export interface APIDateCheckStatModel {
  date?: string;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  count?: number | string;
}

export interface APIDateMoneyStatModel {
  date?: string;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  amount?: number | string;
}

/**
 * Filter for date only values with various comparison operators
 * @example {"condition":"equals","value":"2024-01-01"}
 */
export interface APIDateOnlySearchFilter {
  condition?: null | APIDateTimeOperators;
  /** @format date */
  value?: null | string;
  /**
   * Used for "between" condition as the upper bound
   * @format date
   */
  valueTo?: null | string;
  hasValue?: boolean;
}

export enum APIDateTimeOperators {
  Equals = 'Equals',
  NotEquals = 'NotEquals',
  GreaterThanOrEqual = 'GreaterThanOrEqual',
  GreaterThan = 'GreaterThan',
  LessThanOrEqual = 'LessThanOrEqual',
  LessThan = 'LessThan',
  Between = 'Between',
}

/** Filter for datetime values with various comparison operators */
export interface APIDateTimeSearchFilter {
  condition?: null | APIDateTimeOperators;
  /** @format date-time */
  value?: null | string;
  /**
   * Used for "between" condition as the upper bound
   * @format date-time
   */
  valueTo?: null | string;
  hasValue?: boolean;
}

/** Filter for decimal values */
export interface APIDecimalSearchFilter {
  condition?: null | APINumericOperators;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  value?: null | number | string;
  /**
   * Used for "between" condition as the upper bound
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  valueTo?: null | number | string;
  hasValue?: boolean;
}

export enum APIEntityType {
  Payment = 'Payment',
  Payee = 'Payee',
  Bank = 'Bank',
  Settings = 'Settings',
  User = 'User',
  Organization = 'Organization',
  ApiClientToken = 'ApiClientToken',
  BlankCheckRange = 'BlankCheckRange',
  Billing = 'Billing',
}

export enum APIEventType {
  PaymentCreated = 'PaymentCreated',
  PaymentUpdated = 'PaymentUpdated',
  PaymentDeleted = 'PaymentDeleted',
  PaymentVoided = 'PaymentVoided',
  PaymentSent = 'PaymentSent',
  PaymentApproved = 'PaymentApproved',
  PaymentResented = 'PaymentResented',
  BlankCheckGenerated = 'BlankCheckGenerated',
  PayeeCreated = 'PayeeCreated',
  PayeeUpdated = 'PayeeUpdated',
  PayeeDeleted = 'PayeeDeleted',
  BankCreated = 'BankCreated',
  BankUpdated = 'BankUpdated',
  BankDeleted = 'BankDeleted',
  UserCreated = 'UserCreated',
  UserUpdated = 'UserUpdated',
  UserDeleted = 'UserDeleted',
  UserAddedToOrganization = 'UserAddedToOrganization',
  UserRemovedFromOrganization = 'UserRemovedFromOrganization',
  UserRegistered = 'UserRegistered',
  UserUpdatedOwnProfile = 'UserUpdatedOwnProfile',
  UserRightsUpdated = 'UserRightsUpdated',
  SettingsCreated = 'SettingsCreated',
  SettingsUpdated = 'SettingsUpdated',
  ApiClientTokenCreated = 'ApiClientTokenCreated',
  ApiClientTokenEnabled = 'ApiClientTokenEnabled',
  ApiClientTokenDisabled = 'ApiClientTokenDisabled',
  ApiClientTokenDeleted = 'ApiClientTokenDeleted',
  BillingPlanChanged = 'BillingPlanChanged',
  BillingPlanCanceled = 'BillingPlanCanceled',
  BillingSubscriptionStatusChanged = 'BillingSubscriptionStatusChanged',
  BillingCheckPurchaseStarted = 'BillingCheckPurchaseStarted',
  BillingChecksPurchased = 'BillingChecksPurchased',
  BillingCreditUpdated = 'BillingCreditUpdated',
}

export enum APIExportFormat {
  Excel = 'Excel',
  Csv = 'Csv',
}

/** @format binary */
export type APIIFormFile = File;

export enum APINumericOperators {
  Equals = 'Equals',
  NotEquals = 'NotEquals',
  GreaterThanOrEqual = 'GreaterThanOrEqual',
  GreaterThan = 'GreaterThan',
  LessThanOrEqual = 'LessThanOrEqual',
  LessThan = 'LessThan',
  Between = 'Between',
}

export interface APIOrganizationCreditModel {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  organizationId?: string;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  value?: number | string;
  /** The kind of grant on the row, or None when it only records which plan the organization is on. */
  grantType?: APICreditGrantType;
  /** Whether a grant is overriding the plan. */
  isManualGrant?: boolean;
  /** Whether the grant is a one-time pool rather than a monthly cap. */
  isLifetime?: boolean;
  /** Whether the organization is unmetered. */
  isUnlimited?: boolean;
  /**
   * Code of the plan on the row, if any.
   * @example "Pro"
   */
  planCode?: string;
  /**
   * Name of that plan.
   * @example "Pro"
   */
  planName?: string;
  /**
   * When this grant took effect; lifetime usage is counted from here.
   * @format date-time
   */
  createdOn?: string;
  /** @format date-time */
  startDate?: null | string;
  /** @format date-time */
  endDate?: null | string;
  isActive?: boolean;
  /**
   * Bank accounts allowed; -1 is unlimited.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  maxBankAccounts?: number | string;
  /** Whether checks carry the EasyECheck badge. */
  showBadge?: boolean;
  /** Whether the custom check designer is unlocked. */
  hasCheckDesigner?: boolean;
  /** Whether custom email templates are unlocked. */
  hasCustomEmailTemplates?: boolean;
  /** Whether API access is unlocked. */
  hasApiAccess?: boolean;
  /** Whether priority support is included. */
  hasPrioritySupport?: boolean;
  /** Only a monthly plan can expire: lifetime and unlimited grants have no end date. */
  isExpired?: boolean;
}

/** Represents an organization within the system */
export interface APIOrganizationModel {
  /**
   * The name of the organization
   * @maxLength 150
   * @example "Acme Corporation"
   */
  name: string;
  /**
   * A brief description of the organization and its purpose
   * @maxLength 255
   * @example "A leading provider of innovative solutions"
   */
  description?: string;
  /** Indicates whether the organization is a sandbox (test) organization */
  isSandbox: boolean;
  /**
   * The unique identifier or filename of the organization's avatar image
   * @maxLength 40
   * @example "org_logo_123456.png"
   */
  avatar?: string;
  /** Indicates whether the organization has been disabled by a super admin */
  isDisabled: boolean;
  /** The settings of this organization */
  settings?: APISettingModel[];
  /** @format uuid */
  id: string;
}

/** Represents an organization within the system */
export interface APIOrganizationRequestModel {
  /**
   * The name of the organization
   * @maxLength 150
   * @example "Acme Corporation"
   */
  name: string;
  /** Indicates whether the organization is a sandbox (test) organization */
  isSandbox: boolean;
  /**
   * A brief description of the organization and its purpose
   * @maxLength 255
   * @example "A leading provider of innovative solutions"
   */
  description?: string;
  /**
   * /// The avatar image file for the organization
   * ///
   */
  file?: null | APIIFormFile;
  /** @format uuid */
  id: string;
}

/** Filter for user search */
export interface APIOrganizationSearchFilter {
  query?: string;
  /** The search parameter that will be used to search contains criteria the organization ids */
  organizationIds?: string[];
  /** a collection of sort fields */
  searchSortOrders?: APISearchSortOrder[];
  /**
   * The search page number, will be used for offset
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 0
   */
  pageNumber?: number | string;
  /**
   * The count of entities on the page
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 20
   */
  pageSize?: number | string;
}

export interface APIOrganizationStatsModel {
  checksCreated?: APIDateCheckStatModel[];
  checksPrinted?: APIDateCheckStatModel[];
  moneyIssued?: APIDateMoneyStatModel[];
  statusBreakdown?: APIStatusStatModel[];
}

/** The plan an organization is on, with the Stripe state behind it. */
export interface APIOrganizationSubscriptionModel {
  /**
   * Organization the subscription belongs to.
   * @format uuid
   */
  organizationId?: string;
  /** The plan subscribed to. */
  plan?: APIBillingPlanModel;
  /** Lifecycle state as last reported by Stripe. */
  status?: APISubscriptionStatus;
  /**
   * Start of the period currently paid for.
   * @format date-time
   */
  currentPeriodStart?: null | string;
  /**
   * End of the period currently paid for.
   * @format date-time
   */
  currentPeriodEnd?: null | string;
  /** Whether the subscription stops at the end of the period instead of renewing. */
  cancelAtPeriodEnd?: boolean;
  /** Whether the subscription is billed through Stripe, so the billing portal can be opened. */
  hasStripeSubscription?: boolean;
  /**
   * When the subscription started.
   * @format date-time
   */
  createdOn?: string;
  /** @format uuid */
  id: string;
}

export interface APIOrganizationUsageModel {
  /**
   * Checks the organization may issue before it has to buy more. For a metered plan this is the
   * monthly allowance plus whatever purchased checks are left.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  limit?: number | string;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  totalUsed?: number | string;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  remaining?: number | string;
  /** The kind of super admin grant in force, or None when the organization is metered on its plan. */
  grantType?: APICreditGrantType;
  /** Whether the grant is a one-time pool rather than a monthly cap. */
  isLifetime?: boolean;
  /** Whether the organization is unmetered. */
  isUnlimited?: boolean;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  userCount?: number | string;
  isDisabled?: boolean;
  userUsages?: APIUserUsageModel[];
  /**
   * Code of the plan the allowance comes from, or null while a super admin credit grant is
   * overriding the plan.
   * @example "Pro"
   */
  planCode?: string;
  /**
   * Name of that plan.
   * @example "Pro"
   */
  planName?: string;
  /**
   * Checks the plan includes this month, after any per-bank multiplication.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 130
   */
  monthlyIncluded?: number | string;
  /**
   * Checks issued so far this calendar month.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 112
   */
  monthlyUsed?: number | string;
  /**
   * Checks left in this month's plan allowance.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 18
   */
  monthlyRemaining?: number | string;
  /**
   * Purchased checks still available. Drawn on only once the monthly allowance runs out, and
   * they never expire.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 180
   */
  packRemaining?: number | string;
}

export interface APIPayeeExportRequest {
  format?: APIExportFormat;
  /** Column names to include. Null means all columns. */
  columns?: string[];
  /**
   * Number of records to export. Capped at 5000.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  exportPageSize?: null | number | string;
  includeTotalsRow?: boolean;
  /**
   * Filter for name on check with condition operators (contains, equals, startsWith, etc.)
   * Example: { "condition": "contains", "value": "John" }
   */
  nameOnCheck?: APIStringSearchFilter;
  /** Filter for email with condition operators */
  email?: APIStringSearchFilter;
  /** Filter for phone with condition operators */
  phone?: APIStringSearchFilter;
  /** Filter for address with condition operators */
  address?: APIStringSearchFilter;
  /** Filter for city with condition operators */
  city?: APIStringSearchFilter;
  /** Filter for state with condition operators */
  state?: APIStringSearchFilter;
  /** Filter for zip with condition operators */
  zip?: APIStringSearchFilter;
  /**
   * Gets or sets the status of the payee.
   * This property is nullable and indicates the current status of the payee in the system.
   */
  status?: null | APIPayeeStatus;
  /** The search parameter that will be used to search contains criteria the organization ids */
  organizationIds?: string[];
  /** a collection of sort fields */
  searchSortOrders?: APISearchSortOrder[];
  /**
   * The search page number, will be used for offset
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 0
   */
  pageNumber?: number | string;
  /**
   * The count of entities on the page
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 20
   */
  pageSize?: number | string;
}

/** Filter for payee search with advanced filtering options */
export interface APIPayeeGlobalSearchFilter {
  query?: string;
  /** The search parameter that will be used to search contains criteria the organization ids */
  organizationIds?: string[];
  /** a collection of sort fields */
  searchSortOrders?: APISearchSortOrder[];
  /**
   * The search page number, will be used for offset
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 0
   */
  pageNumber?: number | string;
  /**
   * The count of entities on the page
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 20
   */
  pageSize?: number | string;
}

/** Represents a payee entity for check payments */
export interface APIPayeeModel {
  /** The user associated with this payee */
  user?: APIUserModel;
  /**
   * The name that will appear on the check
   * @example "John Smith"
   */
  nameOnCheck?: string;
  /**
   * The email address for contacting the payee
   * @example "john.smith@example.com"
   */
  email?: string;
  /**
   * The phone number for contacting the payee
   * @example "(555) 123-4567"
   */
  phone?: string;
  /**
   * The street address of the payee
   * @example "123 Main Street, Apt 4B"
   */
  address?: string;
  /**
   * The city of the payee's address
   * @example "New York"
   */
  city?: string;
  /**
   * The state or province of the payee's address
   * @example "NY"
   */
  state?: string;
  /**
   * The postal code of the payee's address
   * @example 10001
   */
  zip?: string;
  /** The status of the payee */
  status?: APIPayeeStatus;
  /**
   * Indicates whether this payee is currently disabled
   * @example false
   */
  isDisabled?: boolean;
  /** The organization this payee belongs to */
  organization?: APIOrganizationModel;
  /**
   * The timestamp when this payee record was created
   * @format date-time
   * @example "2025-03-13T10:30:00Z"
   */
  createdOn?: string;
  /**
   * The date and time when this payee record was last updated
   * @format date-time
   * @example "2025-03-14T09:45:00Z"
   */
  updatedOn?: null | string;
  /** @format uuid */
  id: string;
}

/** Model for payee information when making payment requests */
export interface APIPayeeRequestModel {
  /**
   * The unique identifier of the user associated with this payee
   * @format uuid
   * @example "3fa85f64-5717-4562-b3fc-2c963f66afa6"
   */
  userId?: string;
  /** The current status of the payee in the system */
  status?: APIPayeeStatus;
  /**
   * The name that will appear on the check
   * @example "John Doe"
   */
  nameOnCheck?: string;
  /**
   * The email address of the payee
   * @example "john.doe@example.com"
   */
  email?: string;
  /**
   * The contact phone number of the payee
   * @example "+1 (555) 123-4567"
   */
  phone?: string;
  /**
   * The street address of the payee
   * @example "123 Main Street, Apt 4B"
   */
  address?: string;
  /**
   * The city of the payee's address
   * @example "New York"
   */
  city?: string;
  /**
   * The state or province of the payee's address
   * @example "NY"
   */
  state?: string;
  /**
   * The postal code of the payee's address
   * @example 10001
   */
  zip?: string;
}

/** Filter for payee search with advanced filtering options */
export interface APIPayeeSearchFilter {
  /**
   * Filter for name on check with condition operators (contains, equals, startsWith, etc.)
   * Example: { "condition": "contains", "value": "John" }
   */
  nameOnCheck?: APIStringSearchFilter;
  /** Filter for email with condition operators */
  email?: APIStringSearchFilter;
  /** Filter for phone with condition operators */
  phone?: APIStringSearchFilter;
  /** Filter for address with condition operators */
  address?: APIStringSearchFilter;
  /** Filter for city with condition operators */
  city?: APIStringSearchFilter;
  /** Filter for state with condition operators */
  state?: APIStringSearchFilter;
  /** Filter for zip with condition operators */
  zip?: APIStringSearchFilter;
  /**
   * Gets or sets the status of the payee.
   * This property is nullable and indicates the current status of the payee in the system.
   */
  status?: null | APIPayeeStatus;
  /** The search parameter that will be used to search contains criteria the organization ids */
  organizationIds?: string[];
  /** a collection of sort fields */
  searchSortOrders?: APISearchSortOrder[];
  /**
   * The search page number, will be used for offset
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 0
   */
  pageNumber?: number | string;
  /**
   * The count of entities on the page
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 20
   */
  pageSize?: number | string;
}

export enum APIPayeeStatus {
  NotActive = 'NotActive',
  Deleted = 'Deleted',
  Archive = 'Archive',
  Active = 'Active',
  Rejected = 'Rejected',
  PendingForReview = 'PendingForReview',
}

/** Represents the status of a payment-related email. */
export interface APIPaymentEmailStatus {
  /** The delivery status of the email. */
  deliveryStatus: string;
  /** The sender's username. */
  senderUsername: string;
  /** The failure message, if any. */
  failureMessage: string;
  /** The reason for the failure, if any. */
  failureReason: string;
  /** The time the email status was generated. */
  timeGenerated: string;
}

export interface APIPaymentExportRequest {
  format?: APIExportFormat;
  /** Column names to include. Null means all columns. */
  columns?: string[];
  /**
   * Number of records to export. Capped at 5000.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  exportPageSize?: null | number | string;
  includeTotalsRow?: boolean;
  /** The search parameter that will be used to search contains criteria the id */
  id?: string;
  /**
   * Filter for amount with condition operators (equals, greaterThan, lessThan, between, etc.)
   * Example: { "condition": "greaterThan", "value": 100 }
   */
  amount?: APIDecimalSearchFilter;
  /**
   * Filter for check number with condition operators (contains, equals, startsWith, etc.)
   * Example: { "condition": "contains", "value": "1234" }
   */
  checkNumber?: APIStringSearchFilter;
  /**
   * Filter for check date with condition operators (equals, greaterThan, between, etc.)
   * Example: { "condition": "between", "value": "2024-01-01", "valueTo": "2024-12-31" }
   */
  checkDate?: APIDateOnlySearchFilter;
  /** Filter for note with condition operators */
  note?: APIStringSearchFilter;
  /** Filter for memo with condition operators */
  memo?: APIStringSearchFilter;
  /** Filter for name with condition operators */
  name?: APIStringSearchFilter;
  /** Filter for company with condition operators */
  company?: APIStringSearchFilter;
  /** Filter for name on check with condition operators */
  nameOnCheck?: APIStringSearchFilter;
  /** Filter for reference id with condition operators */
  referenceId?: APIStringSearchFilter;
  /** Filter for email with condition operators */
  email?: APIStringSearchFilter;
  /** Filter for phone with condition operators */
  phone?: APIStringSearchFilter;
  /** Filter for address with condition operators */
  address?: APIStringSearchFilter;
  /** Filter for city with condition operators */
  city?: APIStringSearchFilter;
  /** Filter for state with condition operators */
  state?: APIStringSearchFilter;
  /** Filter for zip with condition operators */
  zip?: APIStringSearchFilter;
  /** The search parameter that will be used to search equals criteria echeck */
  eCheck?: null | boolean;
  /** The search parameter that will be used to search equals criteria the status */
  status?: null | APIPaymentStatus;
  /** Filter for kId with condition operators */
  kId?: APIStringSearchFilter;
  /** Filter for bank name with condition operators */
  bankName?: APIStringSearchFilter;
  /**
   * Filter for created date with condition operators
   * Example: { "condition": "greaterThan", "value": "2024-01-01T00:00:00Z" }
   */
  createdOn?: APIDateTimeSearchFilter;
  /**
   * Filter for updated date with condition operators
   * Example: { "condition": "greaterThan", "value": "2024-01-01T00:00:00Z" }
   */
  updatedOn?: APIDateTimeSearchFilter;
  /**
   * Filter for delivery time with condition operators
   * Example: { "condition": "equals", "value": "2024-01-01" }
   */
  deliveryTime?: APIDateOnlySearchFilter;
  /** The search parameter that will be used to search contains criteria the organization ids */
  organizationIds?: string[];
  /** a collection of sort fields */
  searchSortOrders?: APISearchSortOrder[];
  /**
   * The search page number, will be used for offset
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 0
   */
  pageNumber?: number | string;
  /**
   * The count of entities on the page
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 20
   */
  pageSize?: number | string;
}

/** Filter for Payment Global Search */
export interface APIPaymentGlobalSearchFilter {
  query?: string;
  /** The search parameter that will be used to search contains criteria the organization ids */
  organizationIds?: string[];
  /** a collection of sort fields */
  searchSortOrders?: APISearchSortOrder[];
  /**
   * The search page number, will be used for offset
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 0
   */
  pageNumber?: number | string;
  /**
   * The count of entities on the page
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 20
   */
  pageSize?: number | string;
}

/** Represents a payment transaction in the system */
export interface APIPaymentModel {
  /** The bank associated with this payment */
  bank: APIBankModel;
  /**
   * The monetary value of the payment
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   * @example 1250.75
   */
  amount: number | string;
  /**
   * The date when the check was issued
   * @format date
   * @example "2023-10-15"
   */
  checkDate?: string;
  /**
   * The unique number assigned to the check
   * @maxLength 100
   * @example "CH-10045678"
   */
  checkNumber?: string;
  /**
   * Additional information or comments about the payment
   * @maxLength 255
   * @example "Payment for Q3 services"
   */
  note?: string;
  /**
   * Brief description or purpose of the payment
   * @maxLength 255
   * @example "October invoice"
   */
  memo?: string;
  /**
   * Name of the payment recipient or sender
   * @maxLength 100
   * @example "John Doe"
   */
  name?: string;
  /**
   * Company name associated with the payment
   * @maxLength 100
   * @example "Acme Corp"
   */
  company?: string;
  /**
   * Verification code used to validate the payment
   * @maxLength 100
   * @example "VC-987654"
   */
  verifyCode?: string;
  /**
   * External reference identifier for the payment
   * @maxLength 100
   * @example "REF-2023-10-15-001"
   */
  referenceId?: string;
  /** The recipient of the payment */
  payee: APIPayeeModel;
  /**
   * Indicates whether this is an electronic check payment
   * @example true
   */
  eCheck?: boolean;
  /**
   * Indicates count of total printed echecks by user
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 1
   */
  ePrintCount?: number | string;
  /** Current status of the payment transaction */
  status: APIPaymentStatus;
  /** The organization associated with this payment */
  organization: APIOrganizationModel;
  /**
   * Key identifier used for payment tracking
   * @maxLength 100
   * @example "K-12345"
   */
  kId?: string;
  /**
   * Identifier of the user who created this payment
   * @format uuid
   * @example "3fa85f64-5717-4562-b3fc-2c963f66afa6"
   */
  createdById: string;
  /**
   * Date and time when the payment was created
   * @format date-time
   * @example "2023-10-15T14:30:00Z"
   */
  createdOn: string;
  /**
   * Identifier of the user who last updated this payment
   * @format uuid
   * @example "4fa85f64-5717-4562-b3fc-2c963f66afb7"
   */
  updatedById?: null | string;
  /**
   * Date and time when the payment was last updated
   * @format date-time
   * @example "2023-10-16T09:45:00Z"
   */
  updatedOn?: null | string;
  /**
   * Date and time when the payment approximately must be delivered
   * @format date-time
   */
  deliveryTime?: null | string;
  /** @format uuid */
  id: string;
}

export interface APIPaymentRequestModel {
  /**
   * The payment amount
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   * @example 100.5
   */
  amount: number | string;
  /**
   * The date associated with the check
   * @format date-time
   * @example "2023-05-15"
   */
  checkDate: string;
  /**
   * The check number identifier. Positive whole numbers only, surrounding whitespace is trimmed.
   * @maxLength 100
   * @pattern ^\s*\d+\s*$
   * @example 1234567
   */
  checkNumber?: string;
  /**
   * Additional notes for the payment
   * @maxLength 255
   * @example "Payment for services rendered in May"
   */
  note?: string;
  /**
   * Memo line for the payment
   * @maxLength 255
   * @example "Invoice #INV-2023-05"
   */
  memo?: string;
  /**
   * Name of the payment recipient
   * @maxLength 100
   * @example "John Doe"
   */
  name?: string;
  /**
   * Company name associated with the payment
   * @maxLength 100
   * @example "Acme Corporation"
   */
  company?: string;
  /**
   * External reference ID for the payment
   * @maxLength 100
   * @example "REF-2023-1234"
   */
  referenceId?: string;
  /**
   * Indicates if payment is processed as an electronic check
   * @example true
   */
  eCheck?: boolean;
  /**
   * Unique identifier for the bank
   * @format uuid
   * @example "3fa85f64-5717-4562-b3fc-2c963f66afa6"
   */
  bankId: string;
  /**
   * Key identifier for payment tracking
   * @maxLength 100
   * @example "K123456"
   */
  kId?: string;
  /** Current status of the payment */
  status?: null | APIPaymentStatus;
  /**
   * Unique identifier for the payee
   * @format uuid
   * @example "3fa85f64-5717-4562-b3fc-2c963f66afa6"
   */
  payeeId?: null | string;
  /**
   * Name as it should appear on the check
   * @maxLength 100
   * @example "John A. Doe"
   */
  nameOnCheck?: string;
  /**
   * Email address of the payee
   * @maxLength 100
   * @example "john.doe@example.com"
   */
  email?: string;
  /**
   * Phone number of the payee
   * @maxLength 20
   * @example "555-123-4567"
   */
  phone?: string;
  /**
   * Street address of the payee
   * @maxLength 200
   * @example "123 Main Street, Apt 4B"
   */
  address?: string;
  /**
   * City of the payee's address
   * @maxLength 100
   * @example "Springfield"
   */
  city?: string;
  /**
   * State of the payee's address
   * @maxLength 50
   * @example "IL"
   */
  state?: string;
  /**
   * ZIP code of the payee's address
   * @maxLength 20
   * @example 62701
   */
  zip?: string;
  /**
   * Date and time when the payment approximately must be delivered
   * @format date-time
   */
  deliveryTime?: null | string;
}

/** Filter for payment search with advanced filtering options */
export interface APIPaymentSearchFilter {
  /** The search parameter that will be used to search contains criteria the id */
  id?: string;
  /**
   * Filter for amount with condition operators (equals, greaterThan, lessThan, between, etc.)
   * Example: { "condition": "greaterThan", "value": 100 }
   */
  amount?: APIDecimalSearchFilter;
  /**
   * Filter for check number with condition operators (contains, equals, startsWith, etc.)
   * Example: { "condition": "contains", "value": "1234" }
   */
  checkNumber?: APIStringSearchFilter;
  /**
   * Filter for check date with condition operators (equals, greaterThan, between, etc.)
   * Example: { "condition": "between", "value": "2024-01-01", "valueTo": "2024-12-31" }
   */
  checkDate?: APIDateOnlySearchFilter;
  /** Filter for note with condition operators */
  note?: APIStringSearchFilter;
  /** Filter for memo with condition operators */
  memo?: APIStringSearchFilter;
  /** Filter for name with condition operators */
  name?: APIStringSearchFilter;
  /** Filter for company with condition operators */
  company?: APIStringSearchFilter;
  /** Filter for name on check with condition operators */
  nameOnCheck?: APIStringSearchFilter;
  /** Filter for reference id with condition operators */
  referenceId?: APIStringSearchFilter;
  /** Filter for email with condition operators */
  email?: APIStringSearchFilter;
  /** Filter for phone with condition operators */
  phone?: APIStringSearchFilter;
  /** Filter for address with condition operators */
  address?: APIStringSearchFilter;
  /** Filter for city with condition operators */
  city?: APIStringSearchFilter;
  /** Filter for state with condition operators */
  state?: APIStringSearchFilter;
  /** Filter for zip with condition operators */
  zip?: APIStringSearchFilter;
  /** The search parameter that will be used to search equals criteria echeck */
  eCheck?: null | boolean;
  /** The search parameter that will be used to search equals criteria the status */
  status?: null | APIPaymentStatus;
  /** Filter for kId with condition operators */
  kId?: APIStringSearchFilter;
  /** Filter for bank name with condition operators */
  bankName?: APIStringSearchFilter;
  /**
   * Filter for created date with condition operators
   * Example: { "condition": "greaterThan", "value": "2024-01-01T00:00:00Z" }
   */
  createdOn?: APIDateTimeSearchFilter;
  /**
   * Filter for updated date with condition operators
   * Example: { "condition": "greaterThan", "value": "2024-01-01T00:00:00Z" }
   */
  updatedOn?: APIDateTimeSearchFilter;
  /**
   * Filter for delivery time with condition operators
   * Example: { "condition": "equals", "value": "2024-01-01" }
   */
  deliveryTime?: APIDateOnlySearchFilter;
  /** The search parameter that will be used to search contains criteria the organization ids */
  organizationIds?: string[];
  /** a collection of sort fields */
  searchSortOrders?: APISearchSortOrder[];
  /**
   * The search page number, will be used for offset
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 0
   */
  pageNumber?: number | string;
  /**
   * The count of entities on the page
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 20
   */
  pageSize?: number | string;
}

export enum APIPaymentStatus {
  Draft = 'Draft',
  Requested = 'Requested',
  Created = 'Created',
  Void = 'Void',
  OpenToPrint = 'OpenToPrint',
  TryToPrint = 'TryToPrint',
  CouldNotPrint = 'CouldNotPrint',
  Printed = 'Printed',
  Emailed = 'Emailed',
  Delivered = 'Delivered',
  NotDelivered = 'NotDelivered',
  Cleared = 'Cleared',
  Scheduled = 'Scheduled',
}

export interface APIPaymentUserRequestModel {
  /**
   * The payment amount
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   * @example 100.5
   */
  amount: number | string;
  /**
   * The unique identifier of the organization initiating the payment
   * @format uuid
   * @example "3fa85f64-5717-4562-b3fc-2c963f66afa6"
   */
  organizationId: string;
  /**
   * Unique identifier for the bank
   * @format uuid
   * @example "3fa85f64-5717-4562-b3fc-2c963f66afa6"
   */
  bankId: string;
  /**
   * Unique identifier for the payee
   * @format uuid
   * @example "3fa85f64-5717-4562-b3fc-2c963f66afa6"
   */
  payeeId: string;
}

/**
 * What an organization is allowed to do, resolved from its entitlement row or the plan behind it.
 * Separate from BillingPlanModel because a super admin can grant one organization a
 * feature without moving it to another plan.
 */
export interface APIPlanFeaturesModel {
  /**
   * Bank accounts allowed. -1 is unlimited.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 5
   */
  maxBankAccounts?: number | string;
  /** Whether checks carry the EasyECheck badge. */
  showBadge?: boolean;
  /** Whether the custom check designer is unlocked. */
  hasCheckDesigner?: boolean;
  /** Whether custom email templates are unlocked. */
  hasCustomEmailTemplates?: boolean;
  /** Whether API access is unlocked. */
  hasApiAccess?: boolean;
  /** Whether priority support is included. Carried for reporting; nothing in the code gates on it. */
  hasPrioritySupport?: boolean;
  /** Whether the bank account limit applies at all. */
  limitsBankAccounts?: boolean;
}

export interface APIPosition {
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
   */
  x?: number | string;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
   */
  y?: number | string;
}

export interface APIPrintResult {
  success?: boolean;
}

export interface APISchema {
  name?: string;
  type?: string;
  content?: string;
  position?: APIPosition;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
   */
  width?: number | string;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
   */
  height?: number | string;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  fontSize?: null | number | string;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
   */
  rotate?: null | number | string;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
   */
  opacity?: null | number | string;
  readOnly?: null | boolean;
  required?: null | boolean;
  bodyRange?: APIBodyRange;
  isSplit?: null | boolean;
  alignment?: string;
  verticalAlignment?: string;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
   */
  lineHeight?: null | number | string;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$
   */
  characterSpacing?: null | number | string;
  fontColor?: string;
  backgroundColor?: string;
  fontName?: string;
}

export interface APISearchResultOfApiClientTokenModel {
  /** The list of the searched entities */
  result?: APIApiClientTokenModel[];
  /**
   * The search page number, will be used for offset
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 0
   */
  pageNumber?: number | string;
  /**
   * The count of entities on the page
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 20
   */
  pageSize?: number | string;
}

export interface APISearchResultOfAuditModel {
  /** The list of the searched entities */
  result?: APIAuditModel[];
  /**
   * The search page number, will be used for offset
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 0
   */
  pageNumber?: number | string;
  /**
   * The count of entities on the page
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 20
   */
  pageSize?: number | string;
}

export interface APISearchResultOfBankModel {
  /** The list of the searched entities */
  result?: APIBankModel[];
  /**
   * The search page number, will be used for offset
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 0
   */
  pageNumber?: number | string;
  /**
   * The count of entities on the page
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 20
   */
  pageSize?: number | string;
}

export interface APISearchResultOfOrganizationModel {
  /** The list of the searched entities */
  result?: APIOrganizationModel[];
  /**
   * The search page number, will be used for offset
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 0
   */
  pageNumber?: number | string;
  /**
   * The count of entities on the page
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 20
   */
  pageSize?: number | string;
}

export interface APISearchResultOfPayeeModel {
  /** The list of the searched entities */
  result?: APIPayeeModel[];
  /**
   * The search page number, will be used for offset
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 0
   */
  pageNumber?: number | string;
  /**
   * The count of entities on the page
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 20
   */
  pageSize?: number | string;
}

export interface APISearchResultOfPaymentModel {
  /** The list of the searched entities */
  result?: APIPaymentModel[];
  /**
   * The search page number, will be used for offset
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 0
   */
  pageNumber?: number | string;
  /**
   * The count of entities on the page
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 20
   */
  pageSize?: number | string;
}

export interface APISearchResultOfUserModel {
  /** The list of the searched entities */
  result?: APIUserModel[];
  /**
   * The search page number, will be used for offset
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 0
   */
  pageNumber?: number | string;
  /**
   * The count of entities on the page
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 20
   */
  pageSize?: number | string;
}

export interface APISearchSortOrder {
  /**
   * The name of a sort field
   * @default "Id"
   * @example "OrderNumber"
   */
  sortField?: string;
  /** Sort order */
  sortOrder?: APISortOrder;
}

export interface APISetOrganizationCreditRequest {
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  value?: number | string;
  /**
   * The kind of grant to apply. None saves the plan alone, which is how an organization is put on
   * a plan without payment.
   */
  grantType?: APICreditGrantType;
  /** @format date-time */
  startDate?: null | string;
  /** @format date-time */
  endDate?: null | string;
  /**
   * Code of the plan to put the organization on. Null keeps whatever plan it is already on, so
   * setting a grant does not silently unsubscribe it.
   * @example "Pro"
   */
  planCode?: string;
  /**
   * Bank accounts allowed; -1 is unlimited.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  maxBankAccounts?: number | string;
  /** Whether checks carry the EasyECheck badge. */
  showBadge?: boolean;
  /** Whether the custom check designer is unlocked. */
  hasCheckDesigner?: boolean;
  /** Whether custom email templates are unlocked. */
  hasCustomEmailTemplates?: boolean;
  /** Whether API access is unlocked. */
  hasApiAccess?: boolean;
  /** Whether priority support is included. */
  hasPrioritySupport?: boolean;
}

export interface APISettingModel {
  name: APISettingName;
  value: string;
  /** @format uuid */
  id: string;
}

export enum APISettingName {
  NewECheckReceiveEmail = 'NewECheckReceiveEmail',
  AddedToOrganizationEmail = 'AddedToOrganizationEmail',
  ECheckPrintLimit = 'ECheckPrintLimit',
  RedirectEmail = 'RedirectEmail',
  Timezone = 'Timezone',
  MonthlyCheckLimit = 'MonthlyCheckLimit',
}

export enum APISortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface APIStatusStatModel {
  status?: string;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  count?: number | string;
}

export enum APIStringOperators {
  Equals = 'Equals',
  NotEquals = 'NotEquals',
  Contains = 'Contains',
  NotContains = 'NotContains',
  StartsWith = 'StartsWith',
  EndsWith = 'EndsWith',
}

/**
 * Filter for string values with various comparison operators
 * @example {"condition":"contains","value":"test"}
 */
export interface APIStringSearchFilter {
  condition?: null | APIStringOperators;
  value?: string;
  hasValue?: boolean;
}

/** A request to move the organization onto a plan. */
export interface APISubscribeRequestModel {
  /**
   * The plan to move to, by string BillingPlanModel.Code.
   * @maxLength 40
   * @example "Pro"
   */
  planCode: string;
}

/** Lifecycle state of an organization's subscription, mirroring the Stripe subscription statuses */
export enum APISubscriptionStatus {
  Incomplete = 'Incomplete',
  Active = 'Active',
  PastDue = 'PastDue',
  Canceled = 'Canceled',
}

/** Request model for enabling or disabling an API client token. */
export interface APITokenToggleModel {
  /**
   * Specifies whether the token should be enabled or disabled.
   * Set to `true` to enable the token, or `false` to disable it.
   */
  isEnabled?: boolean;
}

/**
 * A request to buy a pack of checks. The price is not accepted from the caller: the server
 * re-quotes the quantity against the pricing table.
 */
export interface APITopUpRequestModel {
  /**
   * Checks to buy.
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 250
   */
  quantity: number | string;
}

export interface APITypeaheadModelOfGuid {
  /**
   * The item id
   * @format uuid
   */
  id: string;
  /**
   * The name of an item
   * @example "TestName"
   */
  name: string;
}

export interface APITypeaheadPayeeFilter {
  /** @format uuid */
  userId?: null | string;
  /**
   * The value pattern to search
   * @example "abc"
   */
  query?: string;
  /**
   * The number of result items to return
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 5
   */
  count?: number | string;
  /**
   * Ids to exclude from search result
   * @example [1,2,3]
   */
  excludedIds?: string[];
  /**
   * Ids to include in search result regardless of other criteria
   * @example [4,5,6]
   */
  includedIds?: string[];
  /**
   * The organization ids to filter the search results by
   * @example [101,102]
   */
  organizationIds?: string[];
}

export interface APITypeaheadRequestModelOfGuid {
  /**
   * The value pattern to search
   * @example "abc"
   */
  query?: string;
  /**
   * The number of result items to return
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 5
   */
  count?: number | string;
  /**
   * Ids to exclude from search result
   * @example [1,2,3]
   */
  excludedIds?: string[];
  /**
   * Ids to include in search result regardless of other criteria
   * @example [4,5,6]
   */
  includedIds?: string[];
  /**
   * The organization ids to filter the search results by
   * @example [101,102]
   */
  organizationIds?: string[];
}

export interface APIUserAuthModel {
  email: string;
  password: string;
}

export interface APIUserInviteModel {
  /** The first name of the registering user. */
  firstName?: string;
  /** The last name of the registering user. */
  lastName?: string;
  /** The email address of the registering user. */
  email?: string;
}

/** Represents a user in the EasyECheck system with their personal information and organizational relationships */
export interface APIUserModel {
  /**
   * The user's first name
   * @maxLength 200
   * @example "John"
   */
  firstName: string;
  /**
   * The user's last name
   * @maxLength 200
   * @example "Smith"
   */
  lastName: string;
  /**
   * The user's email address used for communication and login
   * @maxLength 200
   * @example "john.smith@example.com"
   */
  email: string;
  /**
   * The user's phone number for contact purposes
   * @maxLength 25
   * @example "+1-555-123-4567"
   */
  phone: string;
  /**
   * URL or path to the user's profile image
   * @example "/images/avatars/user123.jpg"
   */
  avatar?: string;
  /** Gets or sets the unique hash identifier associated with the user's chat session. */
  chatHashId: string;
  /** The type of user account indicating their role in the system */
  userType?: APIUserType;
  /**
   * Where the account stands. A member who was added rather than registering - a check
   * recipient, or someone invited who has not accepted - is NotRegistered until they do.
   */
  userStatus?: APIUserStatus;
  /** The authentication token for the user session */
  token?: string;
  /** The organizations this user belongs to with their specific roles */
  userOrganizations: APIUserOrganizationModel[];
  settings: APIUserSettingModel[];
  isPasswordSetup?: boolean;
  /** @format uuid */
  id: string;
}

export interface APIUserOrganizationModel {
  /** Represents an organization within the system */
  organization: APIOrganizationModel;
  userType: APIUserType;
  userRights: APIUserOrganizationRightsModel[];
}

export interface APIUserOrganizationRightsModel {
  right: APIUserRight;
}

/** Represents a user in the EasyECheck system with their personal information and organizational relationships */
export interface APIUserPasswordModel {
  /** The user's current password (not required for users without a local password) */
  currentPassword?: string;
  /** The user's password confirmation for authentication */
  newPassword: string;
}

export interface APIUserRegisterModel {
  /** The first name of the registering user. */
  firstName?: string;
  /** The last name of the registering user. */
  lastName?: string;
  /** The email address of the registering user. */
  email?: string;
  /** The password of the registering user. */
  password?: string;
}

export interface APIUserResetPasswordModel {
  email: string;
  /** Gets or sets the password for the user. */
  password: string;
  /** @format uuid */
  resetPasswordToken: string;
}

export enum APIUserRight {
  ManageOrganization = 'ManageOrganization',
  MemberAdministration = 'MemberAdministration',
  BankAccess = 'BankAccess',
  PaymentProcessing = 'PaymentProcessing',
  PayeeDirectory = 'PayeeDirectory',
  ViewUserActivity = 'ViewUserActivity',
  SettingsAccess = 'SettingsAccess',
  ApiDocumentationAccess = 'ApiDocumentationAccess',
  SuperAdmin = 'SuperAdmin',
}

/** Represents a request model for configuring user rights and access levels. */
export interface APIUserRightsRequestModel {
  /**
   * Gets or sets the collection of user rights to be assigned.
   * This property is required and cannot be null.
   */
  rights: APIUserRight[];
  /**
   * Gets or sets the access level for the user.
   * This property is required and defaults to UserType.User.
   */
  userType: APIUserType;
}

/** Filter for user search */
export interface APIUserSearchFilter {
  /** The search parameter that will be used to search contains criteria the id */
  id?: string;
  /** Filter for first name with condition operators */
  firstName?: APIStringSearchFilter;
  /** Filter for last name with condition operators */
  lastName?: APIStringSearchFilter;
  /** Filter for email with condition operators */
  email?: APIStringSearchFilter;
  /** Filter for phone with condition operators */
  phone?: APIStringSearchFilter;
  /** The search parameter that will be used to search equals to the user type */
  userType?: null | APIUserType;
  /** The search parameter that will be used to search equals to the user status */
  userStatus?: null | APIUserStatus;
  /** The search parameter that will be used to search contains criteria the organization id */
  organizationIds?: string[];
  /** The search parameter that will be used to search contains criteria the user rights */
  userRights?: null | APIUserRight;
  /** a collection of sort fields */
  searchSortOrders?: APISearchSortOrder[];
  /**
   * The search page number, will be used for offset
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 0
   */
  pageNumber?: number | string;
  /**
   * The count of entities on the page
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   * @example 20
   */
  pageSize?: number | string;
}

/** Represents a user setting in the EasyECheck system */
export interface APIUserSettingModel {
  /** Represents the type of user setting */
  type?: APIUserSettingType;
  /** Represents the value of the user setting */
  value?: string;
}

export enum APIUserSettingType {
  UserTour = 'UserTour',
}

export enum APIUserStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Deleted = 'Deleted',
  NotRegistered = 'NotRegistered',
}

export enum APIUserType {
  User = 'User',
  Admin = 'Admin',
  Editor = 'Editor',
  SuperAdmin = 'SuperAdmin',
}

export interface APIUserUsageModel {
  /** @format uuid */
  userId?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  used?: number | string;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  remaining?: number | string;
}
